const fallback = () => {
  console.error('Incorrect Avatar data provider.');
  return Promise.reject();
};
const dp = {
  getAvatar: fallback,
  getName: fallback,
  resolveId: fallback
};
export const getAvatarDataProvider = () => {
  // ensure to return same instance as this function could be called in
  // hooks frequently.
  return dp;
};
//# sourceMappingURL=AvatarDataProvider.js.map